import axios from 'axios';
import cn from 'classnames';
import { FC, useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';
import { baseUrl } from 'utils';
import { Icon } from 'components/Icon';
import SwiperCore, { Navigation, Autoplay } from 'swiper';

import styles from './Partners.module.scss';

import arrow from 'assets/sprite/arrow.svg';

interface IPartner {
  link: string;
  text?: string;
}

interface IPartners {
  className?: string;
  isLight?: boolean;
}

export const Partners: FC<IPartners> = ({ className, isLight }) => {
  const [partners, setPartners] = useState<IPartner[]>([]);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    axios.get(`${baseUrl}/partners/`).then(res => {
      setPartners(res.data?.data);
    });
  }, []);

  useEffect(() => {
    setInitialized(true);
  }, [partners]);

  const sliderAutoplayDelay = Number(process.env.REACT_APP_SWIPER_AUTOPLAY_DELAY);
  const sliderAutoplaySpeed = Number(process.env.REACT_APP_SWIPER_AUTOPLAY_SPEED);

  SwiperCore.use([Navigation, Autoplay]);

  const { t } = useTranslation();

  return (
    <div className={cn(styles.root, isLight ? styles.isLight : '', className)}>
      {!!partners.length && <h2 className={styles.title}>{t('trust')}</h2>}
      {initialized && (
        <div className={styles.inner}>
          <button ref={navigationPrevRef} className={cn(styles.arrow, styles.arrowPrev)}>
            <Icon className={styles.arrow} id={arrow.id} viewBox={arrow.viewBox} />
          </button>
          <Swiper
            wrapperClass={styles.wrapper}
            className={styles.swiper}
            modules={[Navigation, Autoplay]}
            slidesPerView={2}
            spaceBetween={20}
            autoplay={{
              delay: sliderAutoplayDelay,
              pauseOnMouseEnter: true,
              stopOnLastSlide: false
            }}
            speed={sliderAutoplaySpeed}
            navigation={{
              prevEl: navigationPrevRef.current,
              nextEl: navigationNextRef.current
            }}
            breakpoints={{
              480: {
                slidesPerView: 3
              },
              768: {
                slidesPerView: 4
              }
            }}
          >
            {partners.map((item, index) => {
              return (
                <SwiperSlide key={index} className={styles.item}>
                  <img
                    className={styles.img}
                    src={item.link}
                    alt={item.text || 'partnerLogo'}
                    title={item.text || ''}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
          <button ref={navigationNextRef} className={cn(styles.arrow, styles.arrowNext)}>
            <Icon className={styles.arrow} id={arrow.id} viewBox={arrow.viewBox} />
          </button>
        </div>
      )}
    </div>
  );
};
